import React from 'react';
import propTypes from 'prop-types';
import posed, { PoseGroup } from 'react-pose';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Control, Field, Label, Help } from 'src/ui/mui-ui-kit';

const HelperWrapper = posed.div({
  enter: {
    opacity: 1,
    x: 0,
  },
  exit: {
    opacity: 0,
    x: -10,
  },
});

export function UiField({
  children = [],
  id = '',
  label = '',
  fieldClassNames,
  labelClassNames,
  hasError,
  iconsPosition,
  icons = null,
  errorMessage,
  showAsterisk = true,
  hideHelp = false,
}) {
  return (
    <Field className={fieldClassNames}>
      {label && (
        <Label htmlFor={id} className={labelClassNames} hasTextColor={hasError}>
          <span>{label}</span>
          {showAsterisk && (
            <span className="icon is-small has-text-danger asterisk">
              <FontAwesomeIcon icon={['fas', 'asterisk']} size="xs" />
            </span>
          )}
        </Label>
      )}
      <Control hasIcons={iconsPosition}>
        {icons}
        {children}
        <div className="helper-wrapper">
          <PoseGroup>
            {!hideHelp && errorMessage && (
              <HelperWrapper key="helper">
                <Help hasTextColor={hasError}>{errorMessage}</Help>
              </HelperWrapper>
            )}
          </PoseGroup>
        </div>
      </Control>
    </Field>
  );
}



// eslint-disable-next-line react/require-default-props
UiField.propTypes = {
  children: propTypes.oneOfType([
    propTypes.arrayOf(propTypes.node),
    propTypes.element,
  ]),
  id: propTypes.string,
  label: propTypes.string,
  fieldClassNames: propTypes.string,
  labelClassNames: propTypes.string,
  hasError: propTypes.string,
  iconsPosition: propTypes.oneOfType([propTypes.bool, propTypes.string]),
  icons: propTypes.arrayOf(
    propTypes.oneOfType([propTypes.node, propTypes.element])
  ),
  errorMessage: propTypes.string,
  showAsterisk: propTypes.bool,
  hideHelp: propTypes.bool,
};
